
import {
  SimplePerformanceMetric,
} from "plugins/@figliolia/metrics"

import "app/beforeCreated"

import plugins_onLoad from "plugins/onLoad"
import components_onLoad from "components/onLoad"
import app_onLoad from "app/onLoad"
import concepts_onLoad from "concepts/onLoad"
import page_onLoad from "pages/onLoad"
import {
  onLoad as widgets_onLoad,
} from "widgets/index"

const onLoad = () => {
  new SimplePerformanceMetric("plugins_onLoad").measure(() => {
    plugins_onLoad()
  })
  new SimplePerformanceMetric("app_onLoad").measure(() => {
    app_onLoad()
  })
  new SimplePerformanceMetric("components_onLoad").measure(() => {
    components_onLoad()
  })
  new SimplePerformanceMetric("widgets_onLoad").measure(() => {
    widgets_onLoad()
  })
  new SimplePerformanceMetric("concepts_onLoad").measure(() => {
    concepts_onLoad()
  })
  new SimplePerformanceMetric("page_onLoad.onLoad").measure(() => {
    page_onLoad.onLoad()
  })
}

export default onLoad
